<template>
    <div class="item-history">
        <div class="left-history">
            <button class="tag tag-black" v-if="history.type == 1">事前入札</button>
            <button class="tag tag-pink" v-if="history.type == 2">オンライン</button>
            <button class="tag tag-brown" v-if="history.type == 3">会場</button>
        </div>
        <div class="right-history">
            <div class="top"><strong>ID: {{ history.member_id }}</strong> {{ formatPrice(history.amount) }} JPY</div>
            <div class="bottom">{{ history.formatted_created_at }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        props: ['history'],
        methods: {
            formatPrice(price) {
                return price.toLocaleString(undefined, {maximumFractionDigits: 0});
            },
        }
    }
</script>
